import { render, staticRenderFns } from "./payments_page.vue?vue&type=template&id=039e8564&"
import script from "./payments_page.vue?vue&type=script&lang=js&"
export * from "./payments_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports